"use strict";

import React from "react";
import Velocity from "velocity-animate";
import ContactFormComplete from "./ContactFormComplete.js";

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.animate = this.animate.bind(this);
  }

  animate() {
    //console.log('animating')
    let element = document.getElementById("service-rh");
    Velocity(
      element,
      {
        opacity: 0.5,
        position: "absolute",
        transform: scale(),
      },
      1000,
    );
  }

  render() {
    return (
      <div className="services-component" id="servicos">
        <h2 className="title section-title">Serviços</h2>
        <div className="services-list">
          <div className="service">
            <div className="service-table">
              <table>
                <thead>
                  <tr>
                    <th rowSpan="2">Serviços</th>
                    <th>Lavagem</th>
                    <th colSpan="4">Detalhe</th>
                  </tr>
                  <tr>
                    <th>Premium</th>
                    <th>Básico</th>
                    <th>Económico</th>
                    <th>Executivo</th>
                    <th>Premium</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Lavagem manual do exterior</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Descontaminação da pintura</td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Polimento da pintura</td>
                    <td></td>
                    <td></td>
                    <td>até 2 fases</td>
                    <td>até 2 fases</td>
                    <td>até 3 fases</td>
                  </tr>
                  <tr>
                    <td>Selagem da pintura</td>
                    <td></td>
                    <td>1 aplicação</td>
                    <td>2 aplicações</td>
                    <td>2 aplicações</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Selagem e enceramento da pintura</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>3 aplicações</td>
                  </tr>
                  <tr>
                    <td>Lavagem do exterior das jantes</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Selagem do exterior das jantes</td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Lavagem da cava das rodas</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Lavagem e selagem das jantes completas</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Lavagem e condicionamento do motor</td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Hidratação dos plásticos interiores e exteriores</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Limpeza dos vidros interiores e exteriores</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Protecção dos vidros exteriores</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Polimento e selagem das ópticas</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Aspiração do interior</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Limpeza do pó interior</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Lavagem de tapetes</td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                    <td>x</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Lavagem de tapetes e carpetes</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Limpeza de estofos em tecido e em pele</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>Hidratação das peles</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>2 aplicações</td>
                    <td>2 aplicações</td>
                  </tr>
                  <tr>
                    <td>Protecção dos tecidos</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>2 aplicações</td>
                    <td>2 aplicações</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>
              <strong>NOTA:</strong> Todos os serviços acima listados estão
              disponíveis individualmente
            </p>
            <p className="text-center title accent">
              Temos disponível um serviço complementar de entrega e levantamento
              de viaturas
            </p>
            <div className="text-center">
              <ContactFormComplete />
            </div>
            <br />
            <p className="text-center title accent">
              Venda de produtos a funcionar pela{" "}
              <a href="https://www.facebook.com/NHPremiumDetails/shop/?referral_code=page_shop_tab&preview=1&ref=page_internal">
                Loja Online do Facebook
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

Services.displayName = "Services";

// Uncomment properties you need
// Home.propTypes = {};
// Home.defaultProps = {};

export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js